import { useState, useEffect } from "react";
import { cards } from "../../lib/api/api";

import { HandySvg } from "handy-svg";
import iconBottomArrow from "../../assets/icons/svg-sprite/arrow-bottom.svg";
import iconPointerRight from "../../assets/icons/svg-sprite/point-arrow-right.svg";

const Actions = ({ cardID, changeMessage, actions }) => {
  const [selectedOption, setSelectedOption] = useState(actions[0]);
  const [selectedActions, setSelectedActions] = useState([]);

  useEffect(() => {
    if (cardID !== null) {
      submitForm();
    }
  }, [cardID]);

  function submitForm() {
    const formElement = document.getElementById("action_form");
    formElement.addEventListener("submit", (e) => {
      e.preventDefault();
      const formData = new FormData(formElement);
      const actions = formData.get("selection").split(",");
      if (actions.length > 0) {
        const banner = document.getElementById("messageBanner");
        banner.style.removeProperty("display");
        setSelectedActions([]);
        actions.forEach((item) => {
          const remoteCheckbox = document.getElementById(
            `action-content-${item}`
          );
          remoteCheckbox.checked = false;
          cards
            .actionActivation(cardID, item, 1)
            .then(() => {
              changeMessage("Заявка на подключение акции успешно создана!");
            })
            .catch((err) => {
              changeMessage("Ошибка подключения, попробуйте позже");
              console.log(err);
            });
        });
      }
    });
  }

  return (
    <>
      <li id="my-actions" className="accordion__list-item">
        <a className="accordion__option" href="#interesting-actions">
          <div className="accordion__option-inner">
            <h3 className="accordion__option-title">Интересные акции</h3>
            <div className="accordion__option-icon">
              <HandySvg
                className="svg-icon"
                src={iconBottomArrow}
                width="20"
                height="20"
              />
            </div>
          </div>
        </a>
        <div className="accordion__section" id="interesting-actions">
          <div className="accordion__section-inner">
            <section className="channel-packs">
              <div className="channel-packs__grid">
                <div className="channel-packs__body">
                  <form id="action_form" method="POST">
                    <input
                      type="hidden"
                      name="selection"
                      value={selectedActions}
                    />
                    <ul className="channel-packs__channel-list js-channel-pack-list">
                      {actions.map((promotion) => (
                        <li
                          className={`action-packs__action-item action-content-${promotion.id}`}
                        >
                          <section className="channel-description js-pack-item">
                            <header className="channel-description__header">
                              <span className="channel-description__arrow-indicator js-pack-btn">
                                <HandySvg
                                  className="svg-icon"
                                  src={iconBottomArrow}
                                  width="16"
                                  height="16"
                                />
                              </span>
                              <div className="channel-description__title-wrap channel-description__title-full">
                                <h6
                                  className={
                                    "channel-description__title js-pack-btn" +
                                    (promotion.is_active === "1"
                                      ? " channel-description__title--checked"
                                      : "")
                                  }
                                  onClick={() => setSelectedOption(promotion)}
                                  style={{ width: "auto" }}
                                >
                                  {promotion.name}
                                </h6>
                              </div>
                              {promotion.is_active === "1" ? (
                                ""
                              ) : (
                                <div className="checkbox channel-description__checkbox">
                                  <input
                                    className="checkbox__input"
                                    id={`action-content-${promotion.id}`}
                                    type="checkbox"
                                    name="actions"
                                    data-twins={promotion.same}
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        setSelectedOption(promotion);
                                        setSelectedActions((prevState) => [
                                          ...prevState,
                                          promotion.id,
                                        ]);
                                        const twins =
                                          e.target.dataset.twins.split(",");
                                        if (twins.length > 0) {
                                          twins.forEach((element) => {
                                            let twin = document.getElementById(
                                              `twin_action_${element}`
                                            );
                                            if (twin)
                                              twin.classList.add(
                                                "js-twin-services"
                                              );
                                          });
                                        }
                                      } else {
                                        setSelectedActions((prevState) =>
                                          prevState.filter(
                                            (elem) => elem !== promotion.id
                                          )
                                        );
                                        const twins =
                                          e.target.dataset.twins.split(",");
                                        if (twins.length > 0) {
                                          twins.forEach((element) => {
                                            let twin = document.getElementById(
                                              `twin_action_${element}`
                                            );
                                            if (twin)
                                              twin.classList.remove(
                                                "js-twin-services"
                                              );
                                          });
                                        }
                                      }
                                    }}
                                  />
                                  <label
                                    id={`twin_action_${promotion.id}`}
                                    className={
                                      "checkbox__label" +
                                      (promotion.is_active !== "1" &&
                                      promotion.same &&
                                      actions.filter(
                                        (element) =>
                                          element.is_active === "1" &&
                                          promotion.same.indexOf(element.id) !==
                                            -1
                                      ).length > 0
                                        ? " js-twin-services"
                                        : "")
                                    }
                                    for={`action-content-${promotion.id}`}
                                  ></label>
                                </div>
                              )}
                            </header>

                            {!promotion.group ||
                            (Array.isArray(promotion.group) && promotion.group.length === 0) ||
                            (typeof promotion.group === 'object' && !Array.isArray(promotion.group) && promotion.group !== null && Object.keys(promotion.group).length === 0) ||
                            (typeof promotion.group === 'string' && promotion.group.trim() === "") ? (
                              <div
                                className="channel-description__body js-pack-content"
                                data-id={`action-content-${promotion.id}`}
                              >
                                <div className="channel-description__text">
                                  <p>
                                    {promotion.description
                                      ? promotion.description
                                      : ""}
                                  </p>
                                </div>
                              </div>
                            ) : (
                              <div
                                className="channel-description__body js-pack-content"
                                data-id={`action-content-${promotion.id}`}
                              >
                                {promotion.group.image && (
                                  <div className="channel-description__pic-wrap">
                                    <img
                                      className="channel-description__pic"
                                      alt={
                                        promotion.group.name
                                          ? promotion.group.name
                                          : promotion.name
                                      }
                                      width="auto"
                                      height="auto"
                                      src={promotion.group.image}
                                    />
                                  </div>
                                )}
                                <div className="channel-description__text">
                                  <span className="channel-description__text-title title title--h3">
                                    {promotion.group.name
                                      ? promotion.group.name
                                      : promotion.name}
                                  </span>
                                  <p>
                                    {promotion.group.description
                                      ? promotion.group.description
                                      : (promotion.description ? promotion.description : "")}
                                  </p>
                                </div>
                              </div>
                            )}
                          </section>
                        </li>
                      ))}
                    </ul>
                    <div
                      className="channel-pack__control"
                      style={
                        selectedActions.length > 0 ? {} : { display: "none" }
                      }
                    >
                      <button
                        className="solid-btn solid-btn--lg solid-btn--blue solid-btn--arrow bttn"
                        type="submit"
                      >
                        Отправить заявку
                        <HandySvg
                          className="svg-icon solid-btn__arrow-right"
                          src={iconPointerRight}
                          width="19"
                          height="10"
                        />
                      </button>
                    </div>
                  </form>
                </div>
                {Object.keys(selectedOption).length === 0 ? (
                  ""
                ) : !selectedOption.group ||
                  (Array.isArray(selectedOption.group) && selectedOption.group.length === 0) ||
                  (typeof selectedOption.group === 'object' && !Array.isArray(selectedOption.group) && selectedOption.group !== null && Object.keys(selectedOption.group).length === 0) ||
                  (typeof selectedOption.group === 'string' && selectedOption.group.trim() === "") ? (
                  <div className="channel-packs__side">
                    <div className="channel-description__text">
                      <span className="channel-description__text-title title title--h3">
                        {selectedOption.name}
                      </span>
                      <p>
                        {selectedOption.description
                          ? selectedOption.description
                          : ""}
                      </p>
                    </div>
                  </div>
                ) : (
                  <div className="channel-packs__side">
                    {selectedOption.group.image && (
                      <div className="channel-description__pic-wrap">
                        <img
                          className="channel-description__pic"
                          alt={
                            selectedOption.group.name
                              ? selectedOption.group.name
                              : selectedOption.name
                          }
                          width="auto"
                          height="auto"
                          src={selectedOption.group.image}
                        />
                      </div>
                    )}
                    <div className="channel-description__text">
                      <span className="channel-description__text-title title title--h3">
                        {selectedOption.group.name
                          ? selectedOption.group.name
                          : selectedOption.name}
                      </span>
                      <p>
                        {selectedOption.group.description
                          ? selectedOption.group.description
                          : (selectedOption.description ? selectedOption.description : "")
                        }
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </section>
          </div>
        </div>
      </li>
    </>
  );
};

export default Actions;
